import { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import DownloadImages from 'components/common/Download/DownloadImages'
import { DownloadType } from 'types'
import ChartHeader from 'components/common/ChartHeader/ChartHeader'
import SlopeChartCommon from 'components/common/SlopeChart/SlopeChart'
import { DOWNLOAD_FILE_NAME } from 'constant'
import { useActions, useAppSelector } from 'hooks'
import { useDownloadSlopeChart } from 'components/common/Download/useDownloadSlopeChart'

export default function SlopeChart() {
  const configuration = useAppSelector(({ vibrancy }) => vibrancy.configuration)
  // Download images
  const fileNameDownload = DOWNLOAD_FILE_NAME.slopeChart
  const [clickDownload, setClickDownload] = useState<DownloadType>(null)
  const { setShowDwnLoader } = useActions()
  // const { handleCallDownload, divRef } = useImageDownload()
  const { handleDownload, divRef } = useDownloadSlopeChart()
  const handleDivDownload = (type: DownloadType) => {
    setShowDwnLoader(true)
    setClickDownload(type)
  }
  useEffect(() => {
    if (clickDownload) {
      // handleCallDownload(clickDownload, { fileName: fileNameDownload, orientation: 'landscape' })
      handleDownload(clickDownload, { fileName: fileNameDownload, orientation: 'landscape' })
      setClickDownload(null)
    }
  }, [clickDownload])

  const yearSource = new Date().getFullYear()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', position: 'relative', overflow: 'hidden' }}>
      <DownloadImages
        handleDownPNG={() => handleDivDownload('png')}
        handleDownJPG={() => handleDivDownload('jpg')}
        handleDownPDF={() => handleDivDownload('pdf')}
      />
      <Box sx={{ padding: '24px' }}>
        <ChartHeader
          header1={`Global AI Vibrancy Ranking, ${Math.min(...configuration.yearFilter.yearRange)}–${Math.max(
            ...configuration.yearFilter.yearRange,
          )} ${configuration.metricValue === 'perCapita' ? '(Per Capita)' : '(Absolute)'}`}
          header2={`Weighted Index Score | Source: ${yearSource} AI Index`}
        />
        <SlopeChartCommon />
      </Box>
      <Box sx={{ padding: '24px', zIndex: -1, position: 'absolute' }} ref={divRef}>
        <ChartHeader
          header1={`Global AI Vibrancy Ranking, ${Math.min(...configuration.yearFilter.yearRange)}–${Math.max(
            ...configuration.yearFilter.yearRange,
          )} ${configuration.metricValue === 'perCapita' ? '(Per Capita)' : '(Absolute)'}`}
          header2={`Weighted Index Score | Source: ${yearSource} AI Index`}
        />
        <SlopeChartCommon is4Downloaded />
      </Box>
    </Box>
  )
}
